import React, { useEffect, useState } from 'react';
import { Container, Col, Row, Modal, Table, Button, Card } from 'react-bootstrap';
import styles from './viewAssessmentModal.module.scss';

const ViewAssessmentModal = (props) => {
    return (
        <Modal
            show={props.showDetailsModal}
            onHide={props.modalClose}
            backdrop="static"
            keyboard={false}
            centered
            size="lg"
        >
            <Modal.Body>
                <div className={styles.modalCancelBtnDiv}>
                    <Button className={styles.modalCancelBtn} onClick={props.modalClose}>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Button>
                </div>
                <div className={styles.modalHeaderDiv}>
                    <span className={styles.modalHeader}>Assignment</span>
                    <hr></hr>

                </div>
                <Container className='mb-3  mt-1'>
                    <Row className='p-3' >
                        <Col xs={12} className="mt-1 mb-1">
                            <span className={styles.rowSubTitle}></span>&nbsp;<span className={styles.rowValues}><div dangerouslySetInnerHTML={{ __html: props.assessmentData.assessment }}></div></span>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
        </Modal>
    )
}

export default ViewAssessmentModal